<div class="header">
  <mat-icon
    aria-hidden="false" 
    aria-label="Back button icon" 
    [fontIcon]="icon"
    (click)="iconClicked()">
  </mat-icon>
</div>